module.exports = "/static/assets/1249e514e1d239a4ef7d47542dc98122.png";